/* MadMouse — Image Compare (before/after slider).
   Uses a single <input type="range"> as control + CSS var --pos to drive clip. */
(function () {
  if (typeof window === 'undefined') return;

  var slides = document.querySelectorAll('[data-mm-compare]');
  if (!slides.length) return;

  slides.forEach(function (root) {
    var input  = root.querySelector('[data-mm-compare-range]');
    var handle = root.querySelector('[data-mm-compare-handle]');
    if (!input) return;

    var sync = function () {
      var raw = parseFloat(input.value);
      var v = isNaN(raw) ? 50 : Math.max(0, Math.min(100, raw));
      root.style.setProperty('--mm-compare-pos', v + '%');
      if (handle) handle.style.left = v + '%';
      root.setAttribute('aria-valuenow', v);
    };

    input.addEventListener('input', sync, { passive: true });
    input.addEventListener('change', sync, { passive: true });

    /* Keyboard support: arrow keys move slider by 1/10 */
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Home') { input.value = 0; sync(); }
      else if (e.key === 'End') { input.value = 100; sync(); }
    });

    sync();

    /* ===== Fullscreen toggle =====
       Estrategia híbrida: CSS fake-fullscreen siempre (funciona en iOS Safari,
       que NO soporta requestFullscreen en elementos no-<video>), y además
       intentamos native fullscreen como bonus en navegadores que lo soporten. */
    var fsBtn = root.querySelector('[data-mm-compare-fs]');
    if (fsBtn) {
      var nativeReq = root.requestFullscreen || root.webkitRequestFullscreen;
      var nativeExit = document.exitFullscreen || document.webkitExitFullscreen;
      var nativeOn = function () {
        return document.fullscreenElement === root || document.webkitFullscreenElement === root;
      };

      var updatePortraitFlag = function () {
        if (!root.classList.contains('is-fullscreen')) return;
        var portrait = window.matchMedia('(orientation: portrait)').matches;
        root.classList.toggle('is-portrait', portrait);
      };

      var enterFs = function () {
        root.classList.add('is-fullscreen');
        document.documentElement.classList.add('mm-fs-lock');
        updatePortraitFlag();
        if (nativeReq) {
          try {
            var p = nativeReq.call(root);
            if (p && typeof p.then === 'function') {
              p.then(function () {
                if (screen.orientation && screen.orientation.lock) {
                  screen.orientation.lock('landscape').catch(function () {});
                }
              }).catch(function () { /* user denied: CSS fake-fs remains */ });
            }
          } catch (e) { /* ignore */ }
        }
      };

      var exitFs = function () {
        root.classList.remove('is-fullscreen', 'is-portrait');
        document.documentElement.classList.remove('mm-fs-lock');
        if (nativeOn() && nativeExit) {
          try { nativeExit.call(document); } catch (e) {}
        }
        if (screen.orientation && screen.orientation.unlock) {
          try { screen.orientation.unlock(); } catch (e) {}
        }
      };

      fsBtn.addEventListener('click', function () {
        if (root.classList.contains('is-fullscreen')) exitFs();
        else enterFs();
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && root.classList.contains('is-fullscreen')) exitFs();
      });

      var onNativeFsChange = function () {
        /* Si el navegador sale de fullscreen native pero nuestra clase sigue,
           salimos también para mantener consistencia. */
        if (!nativeOn() && root.classList.contains('is-fullscreen') && document.fullscreenElement !== null) {
          /* otro elemento entró en fullscreen — no hacemos nada */
        }
      };
      document.addEventListener('fullscreenchange', onNativeFsChange);
      document.addEventListener('webkitfullscreenchange', onNativeFsChange);

      window.addEventListener('orientationchange', updatePortraitFlag);
      window.addEventListener('resize', updatePortraitFlag);
      var mq = window.matchMedia('(orientation: portrait)');
      if (mq.addEventListener) mq.addEventListener('change', updatePortraitFlag);
      else if (mq.addListener) mq.addListener(updatePortraitFlag);
    }
  });
})();
